module.exports = __webpack_public_path__ + "static/media/mind-middle-right.6b399948.svg";